import { render, staticRenderFns } from "./FolderViewSidebar.vue?vue&type=template&id=07f6f300&scoped=true&"
import script from "./FolderViewSidebar.vue?vue&type=script&lang=js&"
export * from "./FolderViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FolderViewSidebar.vue?vue&type=style&index=0&id=07f6f300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f6f300",
  null
  
)

export default component.exports